export default __webpack_public_path__ + "static/media/logo_samatur_passagens.dde31338.webp";